import { SSOState } from './state';
import { TENANT_NAME } from './constants';
import {
	AUTH_REQUEST, AUTH_ERROR, AUTH_LOGOUT, AUTH_AUTOLOGIN, LOCALIZATION_REQUEST, AUTH_SUCCESS, AUTH_USER, ERROR, LOGGED_USER, SSO_CHECK, SSO_STATE_UPDATE,
	SSO_SIGNOUT, SSO_URL, SSO_AUTH_USER, RESET, AUTH_LOGOUT_IF_APPLICABLE
} from '../actionTypes';
import { loginSSOService, loginFormService } from '../../services';
import { types as externalTypes } from '../external/types';
import { localizeLocal } from '../../mixins/localization';
import { showConfirm, showAlert, showNotification } from '@/main/utils/notifications';
import { Loading } from 'element-ui';
const channel = new BroadcastChannel('sessionEnd');

export const actions = {
	async [AUTH_REQUEST]({ commit, dispatch }, user) {
		const loadingInstance1 = Loading.service({ fullscreen: true })
		try {
			var language = localStorage.getItem("i18nextLng");
			if ((typeof language === "string" && language.length === 0) ||(language === null)) {
				language = navigator.languages[0].split('-')[0];
  			}
			language = (language == 'tw' ? 'zh' : language);
			const respAtiveUser = await loginFormService.activeLogin(user);
			if(respAtiveUser.data == "true" || respAtiveUser.data == true)
				{
					await showConfirm({
					message: localizeLocal('UserActiveSessionMsg',language),
					title: 'Notification',
					options: {
						type: 'info',
						cancelButtonText: 'Cancel',
						confirmButtonText: 'Ok',
						callback: async (action) => {
							if (action === 'confirm') {
                   				try { channel.postMessage({ type: 'sessionEnd', time: Date.now() }); } catch (e) { /* channel closed */ }
								let resp = await loginFormService.logIn(user);
								if (resp == 'Password Expired')
								{
									await showNotification({
										title: localizeLocal('PasswordExpiredTitle',language),
										message: localizeLocal('PasswordExpired',language),
										type: 'error',
									});
								}
								else if (resp == 'Account Locked')
								{
									await showNotification({
										title: localizeLocal('AccountLockedTitle',language),
										message: localizeLocal('AccountLockedMessage',language),
										type: 'error',
									});
								}
								else {
									await dispatch(AUTH_USER);
									setTimeout(() => {
										loadingInstance1.close()
									  }, 2000);
									return resp;
								}

							}
							else
							{
								setTimeout(() => {
									loadingInstance1.close()
								  }, 2000);	
							}
						},
					},
				});
			}
			else
			{
				const resp = await loginFormService.logIn(user);
				if (resp =='Password Expired')
				{
					await showNotification({
						title: localizeLocal('PasswordExpiredTitle',language),
						message: localizeLocal('PasswordExpired',language),
						type: 'error',
					});
				}
				else if (resp == 'Account Locked') {
					await showNotification({
						title: localizeLocal('AccountLockedTitle', language),
						message: localizeLocal('AccountLockedMessage', language),
						type: 'error',
					});
				}
				else {
					await dispatch(AUTH_USER);
					setTimeout(() => {
						loadingInstance1.close()
					  }, 2000);
					return resp;
				}
			}
		} catch (err) {
			dispatch(ERROR, { err }, { root: true });
			commit(AUTH_ERROR, { message: err });
			if (sessionStorage.getItem('loggedIn') === 'true') {	
				commit(AUTH_LOGOUT);
				commit(LOGGED_USER, null, { root: true });
			}
			setTimeout(() => {
				loadingInstance1.close();
			  }, 2000);
			return err;
		}
	},

	async [AUTH_USER]({ commit, dispatch }) {
		try {
			const resp = await loginFormService.loggedUser();
			await dispatch(LOCALIZATION_REQUEST);
			commit(AUTH_SUCCESS);
			commit(LOGGED_USER, resp.data, { root: true });
			if (process.env.VUE_APP_USE_MPOV_EXTERNAL === 'true') {
				await dispatch(`external/${externalTypes.actions.INIT_EXTERNAL_MODULES}`, { root: true });
			}
			return resp;
		} catch (err) {
			dispatch(ERROR, { err }, { root: true });
			commit(AUTH_ERROR, { message: err });
			if (sessionStorage.getItem('loggedIn') === 'true') {	
				commit(AUTH_LOGOUT);
				commit(LOGGED_USER, null, { root: true });
			}
			return err;
		}
	},

	async [AUTH_LOGOUT]({ commit, dispatch }, data = { showError: false }) {
		try {

			const resp = await loginFormService.logOut();
			// TODO: KUB - Totoal store reset
			commit(AUTH_LOGOUT);
			commit(LOGGED_USER, null, { root: true });			
			return resp;			
		} catch (err) {
			dispatch(ERROR, { err }, { root: true });
			commit(AUTH_ERROR, { message: err, showError: data.showError });
			commit(AUTH_LOGOUT);
			commit(LOGGED_USER, null, { root: true });			
			return err;
		}		
	},
	async [AUTH_LOGOUT_IF_APPLICABLE]({ commit, dispatch }, data = { showError: false }) {
		try {

			const resp = await loginFormService.logOutIfApplicable();
			return resp;			
		} catch (err) {
			dispatch(ERROR, { err }, { root: true });
			return err;
		}		
	},
	async [AUTH_AUTOLOGIN]({ commit, dispatch }) {
		try {
			const resp = await loginFormService.autoLogon((new URL(document.location)).searchParams.get("jwt") == null ? null : (new URL(document.location)).searchParams.get("jwt"));
			if(resp)
			{
				commit(AUTH_AUTOLOGIN, resp.data);
				return resp;
			}
		} catch (err) {
			dispatch(ERROR, { err }, { root: true });
			commit(AUTH_ERROR, { message: err });
			return err;
		}
	},
	async [SSO_CHECK]({ commit, dispatch }) {
		commit(SSO_STATE_UPDATE, SSOState.Checking);
		const loadingInstance1 = Loading.service({ fullscreen: true })
		try {


			var resp;
			const params = new URL(document.location).searchParams;
			const codeParam = params.get("code");
			if (params.get("Target") != null) {
				const url = (await loginFormService.GRPUrl()).data;
				window.location.href = url;
			}
			else if (codeParam != null) {
				// Strip the entire query string synchronously before the async call
				// to prevent Login.vue remounts from re-sending the same code (fixes duplicate calls / 429s)
				history.replaceState(null, '', window.location.pathname);
				const jwtDetails = await loginFormService.GRPAuthCode(codeParam);
				if (jwtDetails.data.id_token != null) {
					window.localStorage.setItem(TENANT_NAME, jwtDetails.data.tenant_name);
					resp = await loginFormService.GRPLogin(jwtDetails.data.token_type + ' ' + jwtDetails.data.id_token, jwtDetails.data.tenant_name);
					resp = await loginFormService.loggedUser(jwtDetails.data.token_type + ' ' + jwtDetails.data.id_token);
					await dispatch(LOCALIZATION_REQUEST);
					commit(AUTH_SUCCESS);
					commit(LOGGED_USER, resp.data, { root: true });
					if (process.env.VUE_APP_USE_MPOV_EXTERNAL === 'true') {
						await dispatch(`external/${externalTypes.actions.INIT_EXTERNAL_MODULES}`, { root: true });
					}
					setTimeout(() => {
						loadingInstance1.close();
					}, 2000);
					return resp;

				}
				else {
					sessionStorage.setItem('loggedIn', 'false');
					window.location.href = `${process.env.VUE_APP_HTTP_DOMAIN}`;
				}
			}
			else {
				sessionStorage.setItem('loggedIn', 'false');
				return false;
			}
			//const resp = await loginFormService.loggedUser();



		} catch (err) {
			commit(SSO_STATE_UPDATE, SSOState.CheckingError);
			setTimeout(() => {
				loadingInstance1.close();
			}, 2000);
			return SSOState.CheckingError;
		}
	},
	async [SSO_URL]({ commit, dispatch }) {
		try {
			const resp = await loginFormService.GRPUrl();
			return resp.data;
		} catch (err) {
			// dispatch(ERROR, { err }, { root: true });
			// commit(AUTH_ERROR, { message: err });
			// commit(AUTH_LOGOUT);
			// commit(LOGGED_USER, null, { root: true });
			return err;
		}
	},

	async [SSO_AUTH_USER]({ commit, dispatch }, payload) {
		try {
			const resp = await loginFormService.loggedUser();
			await dispatch(LOCALIZATION_REQUEST);
			commit(AUTH_SUCCESS, payload);
			commit(LOGGED_USER, resp.data, { root: true });
			if (process.env.VUE_APP_USE_MPOV_EXTERNAL === 'true') {
				await dispatch(`external/${externalTypes.actions.INIT_EXTERNAL_MODULES}`, { root: true });
			}
			return SSOState.Auth;
		} catch (err) {
			dispatch(ERROR, { err });
			commit(AUTH_ERROR, { message: err });
			return err;
		}
	},

	async [SSO_SIGNOUT]({ commit, dispatch }) {
		try {
			await loginSSOService.signOut();
			dispatch(RESET);
			return true;
		} catch (err) {
			dispatch(ERROR, { err });
			commit(AUTH_ERROR, { message: err });
			return err;
		}
	},

	async [RESET]({ commit }) {
		try {
			// JC/TODO: state reset
		} catch (err) {
			commit(AUTH_ERROR, { message: err });
		}
	},
};
channel.onmessage = (e) => {
  if (e.data.type === 'sessionEnd'
	&& sessionStorage.getItem('loggedIn') === 'true' && window.location.pathname !== '/session-over') {
	window.location.href = '/session-over';
  }
};